import { DesignatedSpecialContractIf, EasyCalcResIf, PlanIf, SpecialContractDiscountIf } from "./ifs/EasyCalcRes"
import { DesignatedSpecialContract, SpecialContractDiscount } from "../Const"

// 共通関数

const isLeapYear = (year: number) => {
  if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
    return true
  }
  return false
}
export const getCompStartDate = () => {
  const today = new Date()
  today.setDate(today.getDate() + 30)
  return today
}

export const getCompEndDate = () => {
  const d = getCompStartDate()
  // 始期日がうるう年の場合
  // 始期日が2020/2/29（閏年）の場合、終期日は2021/2/28
  if (isLeapYear(d.getFullYear()) && d.getMonth() === 1 && d.getDate() === 29) {
    d.setFullYear(d.getFullYear() + 1)
    d.setDate(d.getDate() - 1)
    // 終期日がうるう年の場合
    // 始期日2019/2/28（通常年）の場合、終期日は2020/2/29（閏年）
  } else if (isLeapYear(d.getFullYear() + 1) && d.getMonth() === 1 && d.getDate() === 28) {
    d.setFullYear(d.getFullYear() + 1)
    d.setDate(d.getDate() + 1)
  } else {
    d.setFullYear(d.getFullYear() + 1)
  }
  return d
}

const formatAsDictionary = (date: Date) => {
  return {
    year: date.getFullYear().toString(),
    month: `0${date.getMonth() + 1}`.slice(-2),
    day: `0${date.getDate()}`.slice(-2)
  }
}

export const getBirthday = (age: number) => {
  const d = getCompStartDate()
  d.setFullYear(d.getFullYear() - age)
  return {
    year: formatAsDictionary(d).year,
    month: formatAsDictionary(d).month,
    day: formatAsDictionary(d).day
  }
}

const thereExistsSCD = (list: Array<SpecialContractDiscountIf>, value: string) => {
  let hasValue = false
  list.map((x) => {
    if (x["IT-A自動車-割増引コード"] === value) {
      hasValue = true
    }
    return x["IT-A自動車-割増引コード"] === value
  })
  return hasValue
}
const thereExistsDSC = (list: Array<DesignatedSpecialContractIf>, value: string) => {
  let hasValue = false
  list.map((x) => {
    if (x["IT-A自動車-特定特約コード"] === value) {
      hasValue = true
    }
    return x["IT-A自動車-特定特約コード"] === value
  })
  return hasValue
}
const getDSCPricing = (list: Array<DesignatedSpecialContractIf>, value: string) => {
  let pricing = 0
  list.forEach((x) => {
    if (x["IT-A自動車-特定特約コード"] === value) {
      pricing = x["PC-E-保険金額"]
    }
  })
  return pricing
}
/**
 * 車名リスト取得用APIへのリクエスト向けJSON作成
 * @param {string} carModel - 型式
 * @param {string} UUID - UUID
 */
export function createRequestCarList(carModel: string, UUID: string) {
  return {
    "自動車-型式": carModel,
    UUID
  }
}

interface DriverScopeIf {
  "IT-A自動車-特定特約コード": string
}

/**
 * 簡易試算用APIへのリクエスト向けJSON作成
 * @param {string} contractorAge - 主に運転される方（ご契約者）の年齢
 * @param {string} youngestAge - 最若年齢
 * @param {string} licenceColor - 免許の色
 * @param {string} vehicleType - 用途車種
 * @param {string} carModel - 型式
 * @param {string} firstInspectionYear - 初度登録年
 * @param {string} firstInspectionMonth - 初度登録月
 * @param {string} carName - 車名
 * @param {string} hasAEB - AEB有無
 * @param {string} purpose - 主な目的
 * @param {string} distance - 前年走行距離
 * @param {string} location - 主な使用地
 * @param {string} hadAccidents - 過去3年の事故有無
 * @param {string} nonFleetGrade - ノンフリ等級
 * @param {string} UUID - UUID
 * @param {Array<DriverScopeIf>} DriverScope - 運転者範囲
 * @param {string} couponCode - クーポンコード
 * @param {string} gradeDownAccident - 等級ダウン事故
 */
export function createRequestEasyCalc(
  contractorAge: string,
  youngestAge: string,
  licenceColor: string,
  vehicleType: string,
  carModel: string,
  firstInspectionYear: string,
  firstInspectionMonth: string,
  carName: string,
  hasAEB: string,
  purpose: string,
  distance: string,
  location: string,
  hadAccidents: string,
  nonFleetGrade: string,
  UUID: string,
  DriverScope: Array<DriverScopeIf>,
  couponCode: string,
  gradeDownAccident?: string
) {
  return youngestAge !== "-1"
    ? {
        EASIMessage: {
          EASIBody: {
            AppDataFormat: {
              "PC-BB-試算要求_自動車": {
                "IC-G-被保険者": {
                  "BA-G-年月日": {
                    "BA-A-西暦年": getBirthday(parseInt(contractorAge, 10)).year,
                    "BA-A-月": getBirthday(parseInt(contractorAge, 10)).month,
                    "BA-A-日": getBirthday(parseInt(contractorAge, 10)).day
                  },
                  "ITE-G自動車-免許証": {
                    "ITE-E免許証の色": licenceColor
                  }
                },
                "IC-G-保険期間": {
                  "IC-A-開始年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompStartDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompStartDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompStartDate()).day.toString()
                    }
                  },
                  "IC-A-終了年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompEndDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompEndDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompEndDate()).day.toString()
                    }
                  }
                },
                "PC-E-キャンペーンコード": couponCode,
                "IT-G自動車-被保険自動車": {
                  "IT-E自動車-車名": carName,
                  "IT-A自動車-型式": carModel,
                  "BA-G-年月日": {
                    "BA-A-西暦年": firstInspectionYear,
                    "BA-A-月": firstInspectionMonth
                  },
                  "IT-A自動車-用途車種": vehicleType,
                  "ITE-A自動車-AEB装置区分": {
                    "ITE-C自動車-AEB装置区分": hasAEB
                  },
                  "ITE-E自動車-主な使用目的": purpose,
                  "ITE-E自動車-前年走行距離区分": distance,
                  "ITE-E自動車-主な使用地": {
                    "ITE-C自動車-主な使用地": location
                  }
                },
                "IT-G自動車-年齢条件": {
                  "ITE-G自動車-最若年生年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": getBirthday(parseInt(youngestAge, 10)).year,
                      "BA-A-月": getBirthday(parseInt(youngestAge, 10)).month,
                      "BA-A-日": getBirthday(parseInt(youngestAge, 10)).day
                    }
                  }
                },
                "IT-E自動車-等級": nonFleetGrade,
                "IT-E自動車-事故有係数適用期間": hadAccidents,
                "IT-E自動車-等級ダウン事故": gradeDownAccident,
                "IT-G自動車-特定特約": DriverScope,
                UUID
              }
            }
          }
        }
      }
    : {
        EASIMessage: {
          EASIBody: {
            AppDataFormat: {
              "PC-BB-試算要求_自動車": {
                "IC-G-被保険者": {
                  "BA-G-年月日": {
                    "BA-A-西暦年": getBirthday(parseInt(contractorAge, 10)).year,
                    "BA-A-月": getBirthday(parseInt(contractorAge, 10)).month,
                    "BA-A-日": getBirthday(parseInt(contractorAge, 10)).day
                  },
                  "ITE-G自動車-免許証": {
                    "ITE-E免許証の色": licenceColor
                  }
                },
                "IC-G-保険期間": {
                  "IC-A-開始年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompStartDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompStartDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompStartDate()).day.toString()
                    }
                  },
                  "IC-A-終了年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompEndDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompEndDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompEndDate()).day.toString()
                    }
                  }
                },
                "PC-E-キャンペーンコード": couponCode,
                "IT-G自動車-被保険自動車": {
                  "IT-E自動車-車名": carName,
                  "IT-A自動車-型式": carModel,
                  "BA-G-年月日": {
                    "BA-A-西暦年": firstInspectionYear,
                    "BA-A-月": firstInspectionMonth
                  },
                  "IT-A自動車-用途車種": vehicleType,
                  "ITE-A自動車-AEB装置区分": {
                    "ITE-C自動車-AEB装置区分": hasAEB
                  },
                  "ITE-E自動車-主な使用目的": purpose,
                  "ITE-E自動車-前年走行距離区分": distance,
                  "ITE-E自動車-主な使用地": {
                    "ITE-C自動車-主な使用地": location
                  }
                },
                "IT-E自動車-等級": nonFleetGrade,
                "IT-E自動車-事故有係数適用期間": hadAccidents,
                "IT-E自動車-等級ダウン事故": gradeDownAccident,
                "IT-G自動車-特定特約": DriverScope,
                UUID
              }
            }
          }
        }
      }
}
/**
 * 簡易試算用APIからのレスポンス変換
 * @param {EasyCalcResIf} res - 簡易試算用APIからのレスポンス
 */
export function loadResponseEasyCalc(res: EasyCalcResIf) {
  const resContent = res.EASIMessage.EASIBody.AppDataFormat
  const getPlanContents = (plan: PlanIf) => {
    return {
      pricing: {
        oneTime: plan["PC-BB-試算応答_自動車"]["PC-G-合計保険料"]["PC-A-合計保険料"]["PC-E-保険料"],
        totalInstallments: plan["PC-BB-試算応答_自動車"]["PC-G-合計保険料"]["PC-A-年額保険料"]
          ? plan["PC-BB-試算応答_自動車"]["PC-G-合計保険料"]["PC-A-年額保険料"]["PC-E-保険料"]
          : "-",
        firstInstallments: plan["PC-BB-試算応答_自動車"]["PC-G-合計保険料"]["PC-A-分割払初回払込保険料"]
          ? plan["PC-BB-試算応答_自動車"]["PC-G-合計保険料"]["PC-A-分割払初回払込保険料"]["PC-E-保険料"]
          : "-"
      },
      // 基本補償
      basicComp: {
        personalAndObject: true, // 対人・対物賠償
        uninsuredCarAccidents: true, // 無保険車傷害
        otherCarDriving: true, // 他車運転特約
        victimSaving: true // 被害者救済費用特約
      },
      // 各種割引
      discounts: {
        // インターネット割引
        internet: thereExistsSCD(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特約割増引"],
          SpecialContractDiscount.インターネット割引
        ),
        // 電気・ハイブリッド車割引
        EV_HV: thereExistsSCD(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特約割増引"],
          SpecialContractDiscount["電気・ハイブリッド車割引"]
        ),
        // 無事故割引
        noAccident: thereExistsSCD(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特約割増引"],
          SpecialContractDiscount.無事故割引
        ),
        // おとなの２台目割引
        secondCar: false
      },
      // おとなの早割
      earlyPaymentDiscount: {
        // 早割30日
        thirtyDays: thereExistsSCD(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特約割増引"],
          SpecialContractDiscount.おとなの早割30日
        ),
        // 早割50日
        fiftyDays: thereExistsSCD(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特約割増引"],
          SpecialContractDiscount.おとなの早割50日
        )
      },
      // ALSOK
      attachedServices: {
        ALSOK: true
      },
      // ご自身や同乗者への補償
      forYourselfAndPassengers: {
        // 人身傷害
        personalInjury: {
          // 補償範囲
          coverage:
            plan["PC-BB-試算応答_自動車"]["IT-G自動車-担保種目"]["ITE-G自動車-人身傷害"]["IT-E自動車-保険金額制限区分"][
              "IT-C自動車-保険金額制限区分"
            ],
          // 保険金額
          comp: plan["PC-BB-試算応答_自動車"]["IT-G自動車-担保種目"]["ITE-G自動車-人身傷害"]["PC-E-保険金額"]
        },
        // 搭乗者傷害
        passengerInjuryComp:
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-担保種目"]["ITE-G自動車-搭乗者傷害"][
            "ITE-A自動車-搭乗者1名保険金額"
          ]["PC-E-保険金額"]
      },
      // ご自身の車への補償
      forYourCar: {
        // 車両保険タイプ
        type: plan["PC-BB-試算応答_自動車"]["IT-E自動車-車両特約"],
        // 保険金額
        comp: plan["PC-BB-試算応答_自動車"]["IT-G自動車-担保種目"]["IT-G自動車-車両"]["PC-E-保険金額"],
        // 免責金額(1回目)
        deductible1:
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-担保種目"]["IT-G自動車-車両"]["IT-A自動車-車両1事故免責金額"][
            "PC-E-免責金額"
          ],
        // 免責金額(2回目以降)
        deductible2:
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-担保種目"]["IT-G自動車-車両"]["IT-A自動車-車両2回目以降免責金額"][
            "PC-E-免責金額"
          ],
        // 車両新価特約
        originalPriceComp: {
          isAttached: thereExistsDSC(
            plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
            DesignatedSpecialContract.車両新価特約
          ),
          pricing: getDSCPricing(
            plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
            DesignatedSpecialContract.車両新価特約
          )
        },
        // 車両全損修理時特約
        totalLossComp: {
          isAttached: thereExistsDSC(
            plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
            DesignatedSpecialContract.車両全損修理時特約
          ),
          pricing: getDSCPricing(
            plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
            DesignatedSpecialContract.車両全損修理時特約
          )
        },
        // 事故時代車費用特約
        replacementCar: {
          isAttached: thereExistsDSC(
            plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
            DesignatedSpecialContract.事故時代車費用特約
          ),
          pricing: getDSCPricing(
            plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
            DesignatedSpecialContract.事故時代車費用特約
          )
        }
      },
      // その他の補償
      otherComps: {
        // 対物全損時修理差額費用特約
        objectTotalLoss: thereExistsDSC(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
          DesignatedSpecialContract.対物全損時修理差額費用特約
        ),
        // ロードアシスタント特約
        roadAssitance: thereExistsDSC(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
          DesignatedSpecialContract.ロードアシスタンス特約
        ),
        // 弁護士費用特約
        lawyerCost: thereExistsDSC(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
          DesignatedSpecialContract.弁護士費用特約
        ),
        // 個別賠償責任特約
        personalLiability: thereExistsDSC(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
          DesignatedSpecialContract.個人賠償責任特約
        ),
        // 自転車傷害特約
        bicycleDamage: thereExistsDSC(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
          DesignatedSpecialContract.自転車傷害特約
        ),
        // ファミリーバイク特約
        familyBike: false,
        // 車両身の回り品特約
        accessaryDiscount: thereExistsDSC(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特定特約"],
          DesignatedSpecialContract.車両積載動産特約
        ),
        // 新車割引
        newCarDiscount: thereExistsSCD(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特約割増引"],
          SpecialContractDiscount.新車割引
        ),
        // 自動ブレーキ（ASV）割引
        ASVDiscount: thereExistsSCD(
          plan["PC-BB-試算応答_自動車"]["IT-G自動車-特約割増引"],
          SpecialContractDiscount["自動ブレーキ（ＡＳＶ）割引"]
        )
      },
      // 紙の保険証券
      insurancePolicy: {
        paper: true
      }
    }
  }
  return {
    light: getPlanContents(resContent.ライトプラン),
    standard: getPlanContents(resContent.通常プラン),
    fullSupport: getPlanContents(resContent.充実プラン)
  }
}
/**
 * 見積保存用APIへのリクエスト向けJSON作成
 * @param {string} plan - プラン（ライトプラン / スダンダードプラン / フルサポートプラン）
 * @param {string} email - メールアドレス
 * @param {string} password - パスワード
 * @param {string} contractorAge - 主に運転される方（ご契約者）の年齢
 * @param {string} youngestAge - 最若年齢
 * @param {string} licenceColor - 免許の色
 * @param {string} vehicleType - 用途車種
 * @param {string} carModel - 型式
 * @param {string} firstInspectionYear - 初度登録年
 * @param {string} firstInspectionMonth - 初度登録月
 * @param {string} carName - 車名
 * @param {string} hasAEB - AEB有無
 * @param {string} purpose - 主な目的
 * @param {string} distance - 前年走行距離
 * @param {string} location - 主な使用地
 * @param {string} hadAccidents - 過去3年の事故有無
 * @param {string} nonFleetGrade - ノンフリ等級
 * @param {Array<DriverScopeIf>} DriverScope - 運転者範囲
 * @param {string} UUID - UUID
 * @param {string} couponCode - クーポンコード
 * @param {string} gradeDownAccident - 等級ダウン事故
 */
export function createRequestSave(
  plan: string,
  email: string,
  password: string,
  contractorAge: string,
  youngestAge: string,
  licenceColor: string,
  vehicleType: string,
  carModel: string,
  firstInspectionYear: string,
  firstInspectionMonth: string,
  carName: string,
  hasAEB: string,
  purpose: string,
  distance: string,
  location: string,
  hadAccidents: string,
  nonFleetGrade: string,
  DriverScope: Array<DriverScopeIf>,
  UUID: string,
  couponCode: string,
  emailRejectedFlag: string,
  gradeDownAccident: string
) {
  const contractorInfo = {
    "BAE-G-連絡先": {
      "BA-E-Emailアドレス": email
    },
    "BAE-E-パスワード": password,
    "BAE-E-メール拒否区分": emailRejectedFlag
  }
  return youngestAge !== "-1"
    ? {
        EASIMessage: {
          EASIBody: {
            AppDataFormat: {
              "PC-BB-試算要求_自動車": {
                プラン選択: plan,
                "IC-G-契約者": contractorInfo,
                "IC-G-被保険者": {
                  "BA-G-年月日": {
                    "BA-A-西暦年": getBirthday(parseInt(contractorAge, 10)).year,
                    "BA-A-月": getBirthday(parseInt(contractorAge, 10)).month,
                    "BA-A-日": getBirthday(parseInt(contractorAge, 10)).day
                  },
                  "ITE-G自動車-免許証": {
                    "ITE-E免許証の色": licenceColor
                  }
                },
                "IC-G-保険期間": {
                  "IC-A-開始年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompStartDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompStartDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompStartDate()).day.toString()
                    }
                  },
                  "IC-A-終了年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompEndDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompEndDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompEndDate()).day.toString()
                    }
                  }
                },
                "PC-E-キャンペーンコード": couponCode,
                "IT-G自動車-被保険自動車": {
                  "IT-E自動車-車名": carName,
                  "IT-A自動車-型式": carModel,
                  "BA-G-年月日": {
                    "BA-A-西暦年": firstInspectionYear,
                    "BA-A-月": firstInspectionMonth
                  },
                  "IT-A自動車-用途車種": vehicleType,
                  "ITE-A自動車-AEB装置区分": {
                    "ITE-C自動車-AEB装置区分": hasAEB
                  },
                  "ITE-E自動車-主な使用目的": purpose,
                  "ITE-E自動車-前年走行距離区分": distance,
                  "ITE-E自動車-主な使用地": {
                    "ITE-C自動車-主な使用地": location
                  }
                },
                "IT-G自動車-年齢条件": {
                  "ITE-G自動車-最若年生年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": getBirthday(parseInt(youngestAge, 10)).year,
                      "BA-A-月": getBirthday(parseInt(youngestAge, 10)).month,
                      "BA-A-日": getBirthday(parseInt(youngestAge, 10)).day
                    }
                  }
                },
                "IT-E自動車-等級": nonFleetGrade,
                "IT-E自動車-事故有係数適用期間": hadAccidents,
                "IT-E自動車-等級ダウン事故": gradeDownAccident,
                "IT-G自動車-特定特約": DriverScope,
                UUID
              }
            }
          }
        }
      }
    : {
        EASIMessage: {
          EASIBody: {
            AppDataFormat: {
              "PC-BB-試算要求_自動車": {
                プラン選択: plan,
                "IC-G-契約者": contractorInfo,
                "IC-G-被保険者": {
                  "BA-G-年月日": {
                    "BA-A-西暦年": getBirthday(parseInt(contractorAge, 10)).year,
                    "BA-A-月": getBirthday(parseInt(contractorAge, 10)).month,
                    "BA-A-日": getBirthday(parseInt(contractorAge, 10)).day
                  },
                  "ITE-G自動車-免許証": {
                    "ITE-E免許証の色": licenceColor
                  }
                },
                "IC-G-保険期間": {
                  "IC-A-開始年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompStartDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompStartDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompStartDate()).day.toString()
                    }
                  },
                  "IC-A-終了年月日": {
                    "BA-G-年月日": {
                      "BA-A-西暦年": formatAsDictionary(getCompEndDate()).year.toString(),
                      "BA-A-月": formatAsDictionary(getCompEndDate()).month.toString(),
                      "BA-A-日": formatAsDictionary(getCompEndDate()).day.toString()
                    }
                  }
                },
                "PC-E-キャンペーンコード": couponCode,
                "IT-G自動車-被保険自動車": {
                  "IT-E自動車-車名": carName,
                  "IT-A自動車-型式": carModel,
                  "BA-G-年月日": {
                    "BA-A-西暦年": firstInspectionYear,
                    "BA-A-月": firstInspectionMonth
                  },
                  "IT-A自動車-用途車種": vehicleType,
                  "ITE-A自動車-AEB装置区分": {
                    "ITE-C自動車-AEB装置区分": hasAEB
                  },
                  "ITE-E自動車-主な使用目的": purpose,
                  "ITE-E自動車-前年走行距離区分": distance,
                  "ITE-E自動車-主な使用地": {
                    "ITE-C自動車-主な使用地": location
                  }
                },
                "IT-E自動車-等級": nonFleetGrade,
                "IT-E自動車-事故有係数適用期間": hadAccidents,
                "IT-E自動車-等級ダウン事故": gradeDownAccident,
                "IT-G自動車-特定特約": DriverScope,
                UUID
              }
            }
          }
        }
      }
}
